<div class="timer-configuration" [formGroup]="timerForm">
  <div class="content">
    <pdq-card variant="popover" color="white">
      <div class="card-title">
        <pdq-heading element="h5">Enable Countdown Timer</pdq-heading>
        <pdq-slide-toggle formControlName="enableCountdownTimer"></pdq-slide-toggle>
      </div>
      <div class="card-container">
        <span>Add Urgency With A Countdown Timer</span>
      </div>
    </pdq-card>

    <pdq-card variant="popover" color="white">
      <div class="card-title">
        <pdq-heading element="h5">Configure</pdq-heading>
      </div>
      <pdq-divider></pdq-divider>
      <div class="card-container">
        <pdq-heading element="h6">Timer Duration</pdq-heading>
        <div class="timer-duration-row">
          <pdq-input-arrows
            widthSize="fullwidth"
            min="1"
            max="60"
            formControlName="timerDuration"
            placeholder="5"></pdq-input-arrows>
          <pdq-dropdown
            (onChange)="onTimerUnitChange($event)"
            [options]="timerUnitOptions"
            [dirty]="false"
            [defaultOption]="timerForm.get('timerUnit')?.value | primitiveDropdownOptionPipe"></pdq-dropdown>
        </div>
        <span class="timer-info-text">Timer starts when customer reaches checkout</span>

        <pdq-heading element="h6">Time Format</pdq-heading>
        <pdq-radio-group formControlName="timeFormat" label="">
          <pdq-radio-button
            [value]="TIME_FORMATS.DIGITAL"
            text="Digital (01:30:45)"
            [checked]="timerForm.get('timeFormat')?.value === TIME_FORMATS.DIGITAL"></pdq-radio-button>
          <pdq-radio-button
            [value]="TIME_FORMATS.COMPACT"
            text="Compact (1Hr 30m)"
            [checked]="timerForm.get('timeFormat')?.value === TIME_FORMATS.COMPACT"></pdq-radio-button>
        </pdq-radio-group>

        <pdq-heading element="h6">Placement</pdq-heading>
        <pdq-radio-group formControlName="placement" label="">
          @for (placement of timerPlacements | keyvalue; track placement.key) {
            <pdq-radio-button
              [value]="placement.value"
              [text]="placement.key | titlecase | replace: '_' : ' '"
              [checked]="timerForm.get('placement')?.value === placement.value"></pdq-radio-button>
          }
        </pdq-radio-group>

        @if (isPerRowPlacement) {
          <pdq-banner
            variant="attention"
            [content]="'When using Per Row placement, add {countdown} token to at least one row\'s body text to display the timer.'"
            [closable]="false">
          </pdq-banner>
        }

        @if (!isPerRowPlacement) {
          <pdq-heading element="h6">Messages</pdq-heading>
          <div class="messages-subtitle-wrapper">
            <span class="messages-subtitle">Default Message Displayed</span>
            <pdq-button
              class="eye-preview-button"
              variant="empty"
              [icon]="timerPreviewMode === TIMER_STATES.DEFAULT ? 'preview_eye' : 'preview_eye_crossed'"
              [iconColor]="
                timerPreviewMode === TIMER_STATES.DEFAULT ? 'var(--on-surface-default)' : 'var(--on-surface-light)'
              "
              (click)="setTimerPreviewMode(TIMER_STATES.DEFAULT)">
            </pdq-button>
          </div>
          <rich-text-editor
            [control]="timerForm.get('defaultMessage')"
            placeholder="Only {countdown} left to claim this offer!"
            [config]="{
              items: timerDynamicFieldsOptions$ | async,
              triggerChar: '{',
              filterByKey: 'searchTerm',
              removeTriggerCharOnSelect: true,
              descriptionKey: 'description',
              variant: 'categorizedOptions',
            }"></rich-text-editor>
          <p class="timer-info-text">
            Dynamic fields available. Type &#123; to see options.<br />Ex: Use &#123;countdown&#125; to dynamically
            display the time remaining
          </p>

          <div class="field-group">
            <pdq-dropdown
              formControlName="backgroundColor"
              [options]="bannerVariantOptions"
              [fullWidth]="true"
              [title]="'Default style'"></pdq-dropdown>
          </div>

          <div class="messages-subtitle-wrapper">
            <span class="messages-subtitle">Message When Timer Is Low</span>
            <pdq-button
              class="eye-preview-button"
              variant="empty"
              [icon]="timerPreviewMode === TIMER_STATES.LOW ? 'preview_eye' : 'preview_eye_crossed'"
              [iconColor]="
                timerPreviewMode === TIMER_STATES.LOW ? 'var(--on-surface-default)' : 'var(--on-surface-light)'
              "
              (click)="setTimerPreviewMode(TIMER_STATES.LOW)">
            </pdq-button>
          </div>
          <rich-text-editor
            [control]="timerForm.get('lowTimerMessage')"
            placeholder="Hurry - only {countdown} left!"
            [config]="{
              items: timerDynamicFieldsOptions$ | async,
              triggerChar: '{',
              filterByKey: 'searchTerm',
              removeTriggerCharOnSelect: true,
              descriptionKey: 'description',
              variant: 'categorizedOptions',
            }"></rich-text-editor>
          <p class="timer-info-text">
            Dynamic fields available. Type &#123; to see options.<br />Ex: Use &#123;countdown&#125; to dynamically
            display the time remaining
          </p>

          <div class="low-timer-labels-row">
            <span class="low-timer-threshold-label">Show when Remaining time is under:</span>
            <span class="low-timer-threshold-label">Low time style</span>
          </div>
          <div class="timer-duration-row">
            <pdq-input-arrows
              widthSize="fullwidth"
              min="1"
              max="60"
              formControlName="lowTimerThreshold"
              placeholder="5"></pdq-input-arrows>
            <pdq-dropdown
              (onChange)="onLowTimerThresholdUnitChange($event)"
              [options]="lowTimerThresholdUnitOptions"
              [dirty]="false"
              [defaultOption]="
                timerForm.get('lowTimerThresholdUnit')?.value | primitiveDropdownOptionPipe
              "></pdq-dropdown>
            <div class="low-timer-background-wrapper">
              <pdq-dropdown
                formControlName="lowTimerBackgroundColor"
                [options]="bannerVariantOptions"
                [fullWidth]="true"
                class="low-timer-background-dropdown"></pdq-dropdown>
            </div>
          </div>

          <div class="messages-subtitle-wrapper">
            <span class="messages-subtitle">Message When Time Has Expired</span>
            <pdq-button
              class="eye-preview-button"
              variant="empty"
              [icon]="timerPreviewMode === TIMER_STATES.EXPIRED ? 'preview_eye' : 'preview_eye_crossed'"
              [iconColor]="
                timerPreviewMode === TIMER_STATES.EXPIRED ? 'var(--on-surface-default)' : 'var(--on-surface-light)'
              "
              (click)="setTimerPreviewMode(TIMER_STATES.EXPIRED)">
            </pdq-button>
          </div>
          <rich-text-editor
            [control]="timerForm.get('expiredMessage')"
            placeholder="offer expired"
            [config]="{
              items: timerDynamicFieldsOptions$ | async,
              triggerChar: '{',
              filterByKey: 'searchTerm',
              removeTriggerCharOnSelect: true,
              descriptionKey: 'description',
              variant: 'categorizedOptions',
            }"></rich-text-editor>
          <p class="timer-info-text">
            Dynamic fields available. Type &#123; to see options.<br />Ex: Use &#123;countdown&#125; to dynamically
            display the time remaining
          </p>

          <div class="field-group">
            <pdq-dropdown
              formControlName="expiredBackgroundColor"
              [options]="bannerVariantOptions"
              [fullWidth]="true"
              [title]="'Expired time style'"></pdq-dropdown>
          </div>
        }

        <pdq-heading element="h6">Expiration Behavior</pdq-heading>
        <pdq-radio-group formControlName="expirationBehavior" label="">
          @for (behavior of expirationBehaviors | keyvalue; track behavior.key) {
            <pdq-radio-button
              [value]="behavior.value"
              [text]="behavior.key | titlecase | replace: '_' : ' '"
              [checked]="timerForm.get('expirationBehavior')?.value === behavior.value"></pdq-radio-button>
          }
        </pdq-radio-group>
      </div>
    </pdq-card>
  </div>
</div>
